import additionalArea from './additional-area';
import confirmation from './confirmation';
import datepicker from './datepicker';
import error from './error';
import select from './select';
import saveSnapshot from './snapshot-save';
import loadSnapshot from './snapshot-load';
import textStyle from './text-style';
import tradearea from './tradearea';
import serviceAreaStyle from './service-area-style';

export const dialog = {
    additionalArea,
    confirmation,
    datepicker,
    error,
    select,
    saveSnapshot,
    loadSnapshot,
    textStyle,
    tradearea,
    serviceAreaStyle,
};

export default dialog;



// WEBPACK FOOTER //
// ./src/scripts/core/dialog/index.js